






















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AppointmentLookUpViewModel } from '@/models/fixedops/appointment';
import { Base } from '@/components/common/base';
import { PaginationModel } from '@/models/pagedlistmodel';
import { getDetailsHeaders } from '@/views/fixedOps/appointment/appointment';
import {appointmentService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
    },
})
export default class AppointmentDetailPage extends Base {
    public headers = getDetailsHeaders(this);
    public loading: boolean = false;
    public appointmentNumber: string = '';
    public appointment: AppointmentLookUpViewModel = {
        details: [],
    };
    public pagination = new PaginationModel('lineType', true, 5);
    public isAppointmentDetailsLoading: boolean = false;

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.backToList();
        }

        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$parent.$t('appointmentsDetail.btnBackToListTitle') as string, disabled: false, visible: true, class: 'btn', label: this.$parent.$t('appointmentsDetail.btnBackToList') as string, click: 'backToList', icon: 'fas fa-arrow-left' });
        this.$emit('updateToolBar', buttons);
    }

    public mounted(): void {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'appointments');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.appointmentNumber = this.$route.params.appointmentNumber;
        if (this.appointmentNumber && this.appointmentNumber !== '') {
            this.getAppointmentDetails();
        }
    }

    public async getAppointmentDetails() {
        try {
            this.loading = true;
            this.isAppointmentDetailsLoading = true;
            const res = await appointmentService.getAppointmentDetailsAsync(
                this.appointmentNumber,
            );
            this.appointment = res;
            this.pagination.totalItems = this.appointment.details.length;
        } finally {
            this.isAppointmentDetailsLoading = false;
            this.loading = false;
        }
    }

    public backToList(): void {
        if (history.state && history.length > 1) {
            this.$router.back();
        } else {
            this.$router.push({
                name: 'app.appointments',
            });
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
